<template>
  <main class="main">
    <div class="welcome">
      <div class="grid-container">
        <div class="grid-x grid-padding-x">
          <div class="cell">
            <h1>
              {{ $t("home.title", { user: $store.getters.getUser.profile }) }}
            </h1>
            <span>
              {{ getGreeting }},
              {{
                $t("home.subtitle", {
                  user: $store.getters.getUser.profile,
                  // ,'account': $store.getters.getUser.account
                })
              }}
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="grid-container">
      <div class="grid-x align-center">
          <v-risk-upload-dialog
                  :projectId="$route.params.project"
                  v-model="upload.media"
                  :method="upload.method"
                  :isVisible="upload.isVisible"
                  @onAction="onChangeUpload"
          />
        <template v-if="$store.getters.userIsAdmin">
          <div class="cell small-12 small-order-2 large-3 large-order-1">
            <div class="quicklinks box">
              <div class="quicklinks__title">
                <h2>{{ $t("home.quicklinks.title") }}</h2>
              </div>
              <div class="quicklinks__content">
                <ul class="quicklinks__list">
                  <template v-for="item in quickLinks1">
                    <li
                      v-if="$store.getters.userHasPermission(item.permission)"
                    >
                      <router-link
                        :to="item.route"
                        class="button gray"
                        :title="item.title"
                      >
                        <span :class="item.action"></span>
                        {{ item.title }}
                      </router-link>
                    </li>
                  </template>
                </ul>
              </div>
            </div>
            <div class="quicklinks box">
              <div class="quicklinks__title">
                <h2>{{ $t("home.quicklinks2.title") }}</h2>
              </div>
              <div class="quicklinks__content">
                <ul class="quicklinks__list">
                  <template v-for="item in quickLinks2">
                    <li
                      v-if="$store.getters.userHasPermission(item.permission)"
                    >
                      <router-link
                        :to="item.route"
                        class="button gray"
                        :title="item.title"
                      >
                        <span :class="item.action"></span>
                        {{ item.title }}
                      </router-link>
                    </li>
                  </template>
                  <li>
                      <template v-if="$store.getters.userIsAdmin">
                          <button @click="onUploadObject" class="button gray">{{ $t("home.upload-risk") }}</button>
                      </template>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </template>
        <template
          v-if="
            $store.getters.userHasPermission('project_create') &&
            !$store.getters.userIsAdmin
          "
        >
          <div class="cell small-12 small-order-2 large-3 large-order-1">
            <div class="quicklinks box">
              <div class="quicklinks__title">
                <h2>{{ $t("home.quicklinks.title") }}</h2>
              </div>
              <div class="quicklinks__content">
                <ul class="quicklinks__list">
                  <li>
                    <router-link
                      :to="{
                        name: 'customers-create-customer-project',
                        params: {
                          customer: $store.getters.getUser.customer_id,
                        },
                      }"
                      class="button gray"
                      :title="$t('home.quicklinks.create_project')"
                    >
                      <span class="add"></span>
                      {{ $t("home.quicklinks.create_project") }}
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </template>
        <div class="cell medium-12 large-order-2 large-9">
          <div class="grid-x grid-padding-x">
            <div class="cell medium-8">
              <div class="box box--small">
                <form
                  action
                  method="POST"
                  class="filter filter--search"
                  novalidation
                >
                  <div class="grid-x grid-margin-x">
                    <div class="cell medium-6">
                        <template v-if="$store.getters.userIsAdmin">
                            <router-link
                                :to="{ name: 'projects' }"
                                class="button"
                                :title="$t('home.projects.view')"
                                v-if="$store.getters.userHasPermission('project_list')"
                                >{{ $t("home.projects.view") }}</router-link
                            >
                        </template>
                    </div>
                    <div class="cell medium-3">
                      <div class="form-group">
                        <v-datepicker
                          class="form-control form-control--small form-control--date"
                          :placeholder="$t('search.from')"
                          :format="
                            $t('search.from') + ' ' + $helpers.dateFormat
                          "
                          v-model="projectsTableFilter.from"
                          :disabledDates="{
                            days: [6, 0],
                            from: new Date(projectsTableFilter.till),
                          }"
                          :clearButton="true"
                          :language="de"
                          :monday-first="true"
                          @selected="onChangeProjectsTableFromDate"
                        />
                      </div>
                    </div>
                    <div class="cell medium-3">
                      <div class="form-group">
                        <v-datepicker
                          class="form-control form-control--small form-control--date"
                          :placeholder="$t('search.till')"
                          :format="
                            $t('search.till') + ' ' + $helpers.dateFormat
                          "
                          v-model="projectsTableFilter.till"
                          :disabledDates="{
                            days: [6, 0],
                            to: new Date(projectsTableFilter.from),
                          }"
                          :clearButton="true"
                          :language="de"
                          :monday-first="true"
                          @selected="onChangeProjectsTableTillDate"
                        />
                      </div>
                    </div>
                  </div>
                </form>

                <v-table
                  :isLoading="projectsTableLoading"
                  :columns="projectsTableColumns"
                  :items="projectsTableItems"
                  :showShowAll="false"
                >
                  <template slot="deadline" slot-scope="{ row }">
                    <span class="table-date">
                      {{ row.createdon.date | moment("DD") }}
                      <span>{{ row.createdon.date | moment("MMM") }}</span>
                    </span>
                  </template>
                  <template slot="company" slot-scope="{ row }">
                    <span class="table-label">{{
                      row.location.company_name
                    }}</span>
                    <span class="table-description">{{
                      row.address.region
                    }}</span>
                    <span
                      v-if="row.earliest_start"
                      class="table-description table-description--normal"
                    >
                      {{ $t("form.project.earliest_start") }}:
                      {{ $helpers.formatEarliestStartLabel(row.earliest_start) }}
                    </span>
                    <span
                      v-if="!row.earliest_start_comment && row.requested_deadline"
                      class="table-description table-description--normal"
                    >
                      {{ $t("form.project.requested_deadline") }}:
                      {{ row.requested_deadline }}
                    </span>
                  </template>
                  <template slot="address" slot-scope="{ row }">
                    <span class="table-label">{{ row.project_number }}</span>
                    <span class="table-description"
                      >{{ row.address.zipcode }} {{ row.address.city }}</span
                    >
                  </template>
                  <template slot="qm" slot-scope="{ row }">
                    <span class="table-label">{{
                      $helpers.formatNumber(row.qm)
                    }}</span>
                    <span class="table-description">{{ $t("qm") }}</span>
                  </template>
                  <template
                    slot="update"
                    slot-scope="{ row }"
                    v-if="$store.getters.userHasPermission('project_update')"
                  >
                    <router-link
                      :to="{
                        name: 'customers-update-customer-project',
                        params: { customer: row.customer_id, project: row.id },
                      }"
                      class="button button--action button--action--edit button--small"
                      :title="$t('update')"
                      >{{ $t("update") }}</router-link
                    >
                  </template>
                </v-table>
                <v-pagination
                  :currentPage="projectsCurrentPage"
                  :itemsPerPage="projectsItemsPerPage"
                  :items="projectsTableItemsCount"
                  @pageClicked="onChangeProjectsTablePage"
                />
              </div>
            </div>
            <div class="cell medium-4">
              <div class="box box--special">
                <h2>{{ $t("home.notifications.title") }}</h2>
                <v-notifications />
                <div class="box__actions">
                  <router-link
                    :to="{ name: 'notifications' }"
                    class="button"
                    :title="$t('more')"
                    >{{ $t("more") }}</router-link
                  >
                </div>
              </div>
            </div>
          </div>

          <template v-if="$store.getters.userIsAdmin">
            <div class="grid-x grid-padding-x">
              <div class="cell medium-12">
                <div class="progress-graphic box">
                  <div class="progress-graphic__title">
                    <h2>{{ $t("home.projects.title") }}</h2>
                  </div>
                  <div class="progress-graphic__content">
                    <div class="progress-graphic__chart">
                      <canvas id="projects-chart" height="260"></canvas>
                      <div class="progress-graphic__chart__label">
                        {{ $t("home.projects.label") }}
                      </div>
                    </div>
                    <div class="data">
                      <div class="data__numbers">
                        <div data-static>
                          <span
                            :data-static-number="
                              projectsGrapInformation.yesterday
                            "
                            >{{ projectsGrapInformation.yesterday }}</span
                          >
                          <span>{{ $t("home.projects.yesterday") }}</span>
                        </div>
                        <div data-static>
                          <span
                            :data-static-number="projectsGrapInformation.week"
                            >{{ projectsGrapInformation.week }}</span
                          >
                          <span>{{ $t("home.projects.week") }}</span>
                        </div>
                        <div data-static>
                          <span
                            :data-static-number="projectsGrapInformation.month"
                            >{{ projectsGrapInformation.month }}</span
                          >
                          <span>{{ $t("home.projects.month") }}</span>
                        </div>
                        <div data-static>
                          <span
                            :data-static-number="projectsGrapInformation.total"
                            >{{ projectsGrapInformation.total }}</span
                          >
                          <span>{{ $t("home.projects.total") }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Notifications from "./Notifications";
import Table from "./partials/Foundation/Table";
import Pagination from "./partials/Foundation/Pagination";

import Datepicker from "vuejs-datepicker";
import { de } from "vuejs-datepicker/dist/locale";
import Chart from "chart.js";
import RiskUploadDialog from "./partials/RiskUploadDialog.vue";

export default {
  data() {
    return {
      upload: {
          isVisible: false,
          method: "create",
          media: {},
      },
      de: de,
      projectsTableLoading: true,
      projectsTableColumns: [
        {
          key: "deadline",
        },
        {
          key: "company",
        },
        {
          key: "address",
        },
        {
          key: "qm",
          formatter: function (value, row) {
            var output = 0;
            if (row.layers.length > 0) {
              row.layers.forEach(function (layer) {
                output += layer.qm;
              });
            }
            return output;
          },
        },
        {
          key: "update",
          width: "46px",
        },
      ],
      projectsCurrentPage: this.$route.query.page || 1,
      projectsItemsPerPage: 6,
      projectsTableItems: [],
      projectsTableItemsCount: 0,
      projectsTableFilter: {
        from: this.$route.query.from || "",
        till: this.$route.query.till || "",
      },
      projectsGraphWeeks: 4,
      projectsGrapInformation: {
        yesterday: 0,
        week: 0,
        month: 0,
        total: 0,
      },
      quickLinks1: [
        {
          title: this.$t("home.quicklinks.create_project"),
          route: { name: "create-project" },
          action: "add",
          permission: "project_create",
        },
        {
          title: this.$t("home.quicklinks.create_client"),
          route: { name: "customers-create-customer" },
          action: "add",
          permission: "customer_create",
        },
      ],
      quickLinks2: [
        {
          title: this.$t("home.quicklinks2.manage_users"),
          route: { name: "accounts" },
          permission: "administrator",
        },
        {
          title: this.$t("kolonne.title"),
          route: { name: "crew" },
          permission: "administrator",
        },
      ],
    };
  },
  components: {
    vRiskUploadDialog: RiskUploadDialog,
    vNotifications: Notifications,
    vTable: Table,
    vPagination: Pagination,
    vDatepicker: Datepicker,
  },
  created: function () {
    this.onUpdateProjectsTableItems(true);
  },
  mounted: function () {
    this.onUpdateProjectsGraph();
  },
  computed: {
    getGreeting: function () {
      let d = new Date();
      let hours = d.getHours();
      let greeting = "";

      if (hours < 11) {
        greeting = "Guten Morgen";
      } else if (hours >= 11 && hours < 17) {
        greeting = "Guten Tag";
      } else if (hours >= 17 && hours < 20) {
        greeting = "Guten Abend";
      } else if (hours >= 20) {
        greeting = "Gute Nacht";
      }

      return greeting;
    },
  },
  methods: {
      onUploadObject: function () {
          this.upload = {
              isVisible: true,
              method: "create",
              media: {},
          };
      },
      onChangeUpload: function (action, method) {
          switch (action) {
              case "upload":
                  this.objectSuccess = this.$t("form.upload." + method + ".success");

                  break;
          }

          this.upload = {
              isVisible: false,
              method: "create",
              media: {},
          };
      },
    onUpdateProjectsGraph: function () {
      var element = document.getElementById("projects-chart");

      if (element) {
        var data = {},
          labels = {};

        for (var i = 0; i < this.projectsGraphWeeks; i++) {
          var week = this.$moment()
            .endOf("week")
            .subtract(i, "week")
            .isoWeek()
            .toString();

          data[week] = 0;
          labels[week] = this.$t("week", {
            week: week,
          });
        }

        var chart = new Chart(element.getContext("2d"), {
          type: "line",
          data: {
            labels: Object.values(labels),
            datasets: [
              {
                label: this.$t("home.projects.week"),
                fill: false,
                borderColor: "#BD0D30",
                lineTension: 0.1,
                borderWidth: 2,
                backgroundColor: "#ffffff",
                pointRadius: 5,
                pointHoverRadius: 12,
              },
            ],
          },
          options: {
            scales: {
              yAxes: [
                {
                  ticks: {
                    padding: 30,
                    fontFamily: "Arial, sans-serif",
                    fontSize: 12,
                    beginAtZero: false,
                  },
                  gridLines: {
                    borderDash: [3, 4],
                    color: "#a8a8a8",
                    borderWidth: 1,
                    zeroLineColor: "#000000",
                  },
                },
              ],
              xAxes: [
                {
                  ticks: {
                    padding: 15,
                    fontFamily: "Arial, sans-serif",
                    fontSize: 12,
                    stepSize: 2,
                  },
                  gridLines: {
                    display: false,
                    zeroLineColor: "#000000",
                  },
                },
              ],
            },
            legend: {
              display: false,
            },
            layout: {
              padding: {
                right: 5,
                top: 5,
              },
            },
            maintainAspectRatio: false,
          },
        });

        let promise = this.$api
          .clearParams()
          .addParam(
            "from",
            this.$moment()
              .startOf("week")
              .subtract((this.projectsGraphWeeks - 1) * 7, "d")
              .format("YYYY-MM-DD")
          )
          .addParam("till", this.$moment().endOf("week").format("YYYY-MM-DD"))
          .get("projects");

        promise
          .then(
            ((response) => {
              response.data.data.forEach(
                function (row) {
                  var date = this.$moment(row.createdon.date),
                    type = this.$moment().diff(date, "d");

                  if (type === 1) {
                    this.projectsGrapInformation.yesterday++;
                  }

                  if (type <= 6) {
                    this.projectsGrapInformation.week++;
                  }

                  this.projectsGrapInformation.month++;

                  data[date.isoWeek().toString()]++;
                }.bind(this)
              );

              chart.data.datasets.forEach((dataset) => {
                dataset.data = Object.values(data);
              });

              chart.update();

              this.getActiveProjectsCount();
            }).bind(this)
          )
          .catch(
            ((error) => {
              this.projectsGrapInformation.yesterday = 0;
              this.projectsGrapInformation.week = 0;
              this.projectsGrapInformation.month = 0;
              this.projectsGrapInformation.total = 0;

              chart.data.datasets.forEach((dataset) => {
                dataset.data = [];
              });

              chart.update();
            }).bind(this)
          );
      }
    },
    onUpdateFilterParameters: function () {
      let query = {
        page: this.projectsTableCurrentPage,
      };

      for (let key in this.projectsTableFilter) {
        if (this.projectsTableFilter[key]) {
          if (key === "from" || key === "till") {
            query[key] = this.formatDate(this.projectsTableFilter[key]);
          } else {
            query[key] = this.projectsTableFilter[key];
          }
        }
      }

      this.$router.push({ query: query });
    },
    onChangeProjectsTablePage: function (page) {
      this.projectsCurrentPage = page;

      this.onUpdateProjectsTableItems();
    },
    onChangeProjectsTableFromDate: function (date) {
      this.projectsCurrentPage = 1;
      this.projectsTableFilter.from = date;

      this.onUpdateProjectsTableItems();
    },
    onChangeProjectsTableTillDate: function (date) {
      this.projectsCurrentPage = 1;
      this.projectsTableFilter.till = date;

      this.onUpdateProjectsTableItems();
    },
    onUpdateProjectsTableItems: function (firstUpdate) {
      if (!firstUpdate) {
        this.onUpdateFilterParameters();
      }

      let promise = this.$api
        .clearParams()
        .addParam("status", "open,busy,pending")
        .addParam("from", this.formatDate(this.projectsTableFilter.from))
        .addParam("till", this.formatDate(this.projectsTableFilter.till))
        .setPageParams(this.projectsCurrentPage, this.projectsItemsPerPage)
        .setSortParams("createdon", "desc")
        .get("projects");

      promise
        .then(
          ((response) => {
            this.projectsTableItems = response.data.data;
            this.projectsTableItemsCount = response.data.meta.pagination.total;

            this.projectsTableLoading = false;
          }).bind(this)
        )
        .catch(
          ((error) => {
            this.projectsTableItems = [];
            this.projectsTableItemsCount = 0;

            this.projectsTableLoading = false;
          }).bind(this)
        );

      this.projectsTableLoading = true;
    },
    getActiveProjectsCount: function () {
      let promise = this.$api
        .clearParams()
        .addParam("status", "open,busy,pending")
        .get("projects");

      promise
        .then(
          ((response) => {
            this.projectsGrapInformation.total =
              response.data.meta.pagination.total;
          }).bind(this)
        )
        .catch(
          ((error) => {
            this.projectsGrapInformation.total = 0;
          }).bind(this)
        );
    },
    formatDate: function (date) {
      if (date === "" || date === null || date === undefined) {
        return "";
      }

      return this.$moment(date).format("YYYY-MM-DD");
    },
  },
};
</script>